import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';
import { IUnsubscribeReqBody, IUnsubscribeEntity } from '../../../entity';

export interface IUserUnsubscribeUseCase {
    execute(
        username: string,
        authToken: string,
        authSign: string,
        csrfToken: { [key: string]: string },
        reqBody: IUnsubscribeReqBody
    ): Promise<IUnsubscribeEntity>;
}

export class UserUnsubscribeUseCase implements IUserUnsubscribeUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        username: string,
        authToken: string,
        authSign: string,
        csrfToken: { [key: string]: string },
        reqBody: IUnsubscribeReqBody
    ): Promise<IUnsubscribeEntity> {
        return await this.userRepo.unsubscribe(username, authToken, authSign, csrfToken, reqBody);
    }
}
